import { Skeleton, Tag } from 'antd';
import OutlineTag from 'components/UI/Responsive/OutlineTag';
import { Order } from 'model/Order';
import {
  describeSaleType,
  describeStatus,
  formatMoney,
  orderGrandTotal,
  unitGrandTotal,
} from '../Detail/buildMyOrderDetailGroups';
import { statusMap } from '../MyOrdersTable/maps/status';

import * as S from './styles';

interface Props {
  order: Order;
  onClick: () => void;
}

export default function MyOrderCard({ order, onClick }: Props) {
  return (
    <S.Card>
      <S.Body type="button" onClick={onClick}>
        <S.Header>
          <S.Heading>
            <S.Title>
              {order.description}
              {order.conceptName && ` ${order.conceptName.toUpperCase()}`}
            </S.Title>
            <S.Code>
              {order.productCode} · Pedido {order.orderNumber}
            </S.Code>
          </S.Heading>
          <Tag color={statusMap[order.status]?.color}>
            {describeStatus(order)}
          </Tag>
        </S.Header>
        <S.Source>
          <S.Parties>
            {order.siteCode} - {order.siteName} · {order.quality} · {order.packingName}
          </S.Parties>
          <OutlineTag>{describeSaleType(order.saleType)}</OutlineTag>
        </S.Source>
        <S.Quantity>
          {order.packingQuantity} x {order.unitPerPacking} ·{' '}
          {formatMoney(unitGrandTotal(order))}
        </S.Quantity>
        <S.Total>{formatMoney(orderGrandTotal(order))}</S.Total>
      </S.Body>
    </S.Card>
  );
}

export function MyOrderCardSkeleton() {
  return (
    <S.Card aria-hidden>
      <S.Placeholder>
        <Skeleton
          active
          title={{ width: '70%' }}
          paragraph={{ rows: 2, width: ['45%', '100%'] }}
        />
      </S.Placeholder>
    </S.Card>
  );
}
